import { useTranslations } from '@vocab/react';
import { Box, Drawer } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { ComponentProps } from 'react';

import type { UseHandleStatusChangeResponse } from 'src/App/hooks/useHandleStatusChange';
import type { PageConfig } from 'src/libs/PageConfig';

import { JobApplicationDetails } from '../../../App/AppPageBlock/ProfileDrawer/JobApplicationDetails';
import type { IJobApplication } from '../../../stores/JobApplicationStore/JobApplication';

import translations from './.vocab';

import * as styles from './DetailsView.css';

interface Props {
  jobApplication: IJobApplication | null;
  canPurchaseReferenceChecks: boolean;
  isOpen: boolean;
  onClose: () => void;
  applicationCardIsExpanded?: boolean;
  handleStatusChange: UseHandleStatusChangeResponse['handleStatusChange'];
  onUpdateSuccess: () => Promise<void>;
  showSuccessMessageToast: boolean;
  addCustomError: PageConfig['dataDogRum']['addCustomError'];
  userId: string;
  jobId: string;
  seekAdvertiserId: string;
  onMounted: () => void;
  referenceChecksBalance: ComponentProps<
    typeof JobApplicationDetails
  >['referenceChecksBalance'];
}

const DetailsView = ({
  jobApplication,
  canPurchaseReferenceChecks,
  isOpen,
  onClose,
  showSuccessMessageToast,
  applicationCardIsExpanded,
  handleStatusChange,
  onUpdateSuccess,
  addCustomError,
  userId,
  jobId,
  seekAdvertiserId,
  onMounted,
  referenceChecksBalance,
}: Props) => {
  const { t } = useTranslations(translations);

  if (!jobApplication) {
    return null;
  }

  return (
    <Drawer
      id="details-view-drawer"
      width="large"
      open={isOpen}
      onClose={onClose}
      closeLabel={t('Close modal')}
      title=""
    >
      <Box
        data-cy="job-application-details"
        className={styles.jobApplicationDetailsCard}
      >
        <JobApplicationDetails
          jobApplication={jobApplication}
          canPurchaseReferenceChecks={canPurchaseReferenceChecks}
          onUpdateStatusSuccess={onUpdateSuccess}
          applicationCardIsExpanded={applicationCardIsExpanded}
          handleStatusChange={handleStatusChange}
          showSuccessMessageToast={showSuccessMessageToast}
          addCustomError={addCustomError}
          userId={userId}
          jobId={jobId}
          seekAdvertiserId={seekAdvertiserId}
          onMounted={onMounted}
          referenceChecksBalance={referenceChecksBalance}
        />
      </Box>
    </Drawer>
  );
};

export default observer(DetailsView);
